"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgerAPI = exports.DEFAULT_API_URL = void 0;
const tslib_1 = require("tslib");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const currency_enum_1 = require("./enums/currency.enum");
const network_config_1 = require("../config/network/network.config");
const constants_1 = require("../config/constants");
exports.DEFAULT_API_URL = 'https://api.badger.com/v2';
class BadgerAPI {
    constructor(network, baseURL = exports.DEFAULT_API_URL) {
        this.initialize();
        this.client = axios_1.default.create({
            baseURL,
        });
        this.network = network_config_1.NetworkConfig.getConfig(network).network;
    }
    async loadPrices(currency = currency_enum_1.Currency.USD) {
        return this.get('prices', {
            chain: this.network,
            currency,
        });
    }
    async loadSetts(currency = currency_enum_1.Currency.USD) {
        return this.get('setts', {
            chain: this.network,
            currency,
        });
    }
    async loadSett(address, currency = currency_enum_1.Currency.USD) {
        return this.get(`setts/${address}`, {
            chain: this.network,
            currency,
        });
    }
    async loadAccount(address) {
        return this.get(`accounts/${address}`, {
            chain: this.network,
        });
    }
    async loadTokens() {
        return this.get('tokens', {
            chain: this.network,
        });
    }
    async loadProof(address) {
        return this.get('proofs', {
            chain: this.network,
            address,
        });
    }
    async loadGasPrices() {
        return this.get('gas', {
            chain: this.network,
        });
    }
    async loadProtocolMetrics() {
        return this.get('metrics', {
            chain: this.network,
        });
    }
    async loadProtocolSummary(currency = currency_enum_1.Currency.USD) {
        return this.get('value', {
            chain: this.network,
            currency,
        });
    }
    async loadLeaderboard() {
        return this.get('leaderboards/complete', {
            chain: this.network,
        });
    }
    async get(path, params = {}) {
        try {
            const { data } = await this.client.get(path, {
                params,
            });
            return data;
        }
        catch (error) {
            const { response } = error;
            if (response) {
                const { status } = response;
                throw new Error(status.toFixed());
            }
            throw error;
        }
    }
    initialize() {
        for (const config of constants_1.SUPPORTED_NETWORKS) {
            network_config_1.NetworkConfig.register(config);
        }
    }
}
exports.BadgerAPI = BadgerAPI;
(0, tslib_1.__exportStar)(require("./enums"), exports);
(0, tslib_1.__exportStar)(require("./interfaces"), exports);
(0, tslib_1.__exportStar)(require("./types"), exports);
exports.default = BadgerAPI;
//# sourceMappingURL=index.js.map